import { Button } from '@src/design-system/button';
import useTiclickTableConfig from '@shared/hooks/use-ticlick-table-config';
import { TABLES_KEYS } from '@shared/constants/tables-keys';
import type { ActionItemProps } from '@src/design-system/molecules/ticlick-table/ticlick-table-table-actions';

import reminderLogsApi from '@src/features/reminders/services/reminder-logs-api';
import { ReminderLogResendButton } from '@src/features/reminders/components/all-reminders/automated-reminders/reminder-log-resend-button';
import {
  REMINDER_LOG_STATUSES,
  type TReminderLog,
} from '@src/shared/types/reminder';

import { failedRemindersColumns } from './failed-reminders-columns';
import { RefreshLeftSquare } from 'iconsax-react';
import { AutomatedReminderLogViewButton } from '../../all-reminders/automated-reminders/automated-log-view-button';

export function useFailedRemindersDialogTable() {
  const table = useTiclickTableConfig({
    fetchingData: {
      fetchFn: reminderLogsApi.useFetch,
      query: { status: [REMINDER_LOG_STATUSES.failed] },
    },
    options: {
      columns: failedRemindersColumns,
    },
    identifyingData: { tableKey: TABLES_KEYS.reminderLogsTable },
    rowActions: [
      {
        key: 'resend',
        render: (row) => <ReminderLogResendButton ids={[row.original.id]} />,
        minWidth: 36,
      },
      {
        key: 'view',
        render: (row) => <AutomatedReminderLogViewButton row={row} />,
        minWidth: 36,
      },
    ],
  });

  const actions: ActionItemProps<TReminderLog>[] = [
    {
      key: 'resend',
      visibility: 'selection',
      render: (table) => (
        <ReminderLogResendButton
          ids={table.getSelectedRowModel().rows.map((row) => row.original.id)}
          trigger={
            <Button
              type='button'
              variant='ghost'
              className='text-[#211835] border border-[#DBD3F0] h-[40px] px-2.5'
            >
              <RefreshLeftSquare className='size-5! text-secondary-1000' />
              Resend
            </Button>
          }
        />
      ),
    },
  ];

  return { table, actions };
}
